import React from 'react';
import {
  append,
  assocPath,
  compose,
  defaultTo,
  find,
  findIndex,
  modifyPath,
  propEq,
  propOr
} from 'ramda';
import { Collapse, Input } from 'antd';

const Link = ({ label, value, onChange }) => {
  return <div style={{ display: 'flex', alignItems: 'center', justifyItems: 'center', marginTop: '5px' }}>
    <div style={{ width: '100px' }}>{label} :</div>
    <Input onChange={e => onChange(e.target.value)} value={value}/>
  </div>;
};

const CcnOfferTypeSettings = ({
  offerType,
  settings,
  setCcnSettings
}) => {
  const getLinkValue = key => compose(
    propOr('', 'value'),
    defaultTo({}),
    find(propEq('key', key)),
    propOr([], 'links')
  )(settings);

  const updateLinkValue = (key) => (value) => {
    const index = compose(
      findIndex(propEq('key', key)),
      propOr([], 'links')
    )(settings);

    if (index !== -1) {
      setCcnSettings(assocPath([offerType, 'links', index, 'value'], value));
    } else {
      setCcnSettings(modifyPath(
        [offerType, 'links'],
        compose(
          append({ key, value }),
          defaultTo([])
        )
      ));
    }
  };

  return <div>
    <Collapse defaultActiveKey="LINKS">
      <Collapse.Panel header="Liens" key="LINKS">
        <Link
          label="Garanties"
          value={getLinkValue('GARANTIES')}
          onChange={updateLinkValue('GARANTIES')}
        />

        <Link
          label="Cotisations"
          value={getLinkValue('COTISATIONS')}
          onChange={updateLinkValue('COTISATIONS')}
        />
      </Collapse.Panel>
    </Collapse>
  </div>;
};

export default CcnOfferTypeSettings;
